import React from 'react';
import clsx from 'clsx';
import Button from '@ui/Button';
import Icon from '@ui/Icon';
import { StudioClipProps } from '../../StudioClip';
import { CompleteProps } from '.';
import useAudioPlayer from '../../../../lib/useAudioPlayer';

interface PlaybackProps {
  classes: CompleteProps['studioClipCompleteClasses']['classes'];
  clipErrorMessage?: string | null;
  selected: StudioClipProps['selected'];
  playerState: ReturnType<typeof useAudioPlayer>[0]['state'];
  togglePlayback: () => void;
  /**
   * Used in the aria-label for the plaback button.
   */
  name?: string;
  playbackIconFilled?: boolean;
}

const Playback = ({
  classes,
  clipErrorMessage,
  togglePlayback,
  selected,
  playerState,
  name = '',
  playbackIconFilled = false,
}: PlaybackProps) => {
  const isPlaying = playerState === 'PLAYING';
  const isDisabled = playerState === 'ERROR' || playerState === 'LOADING';
  const label = `${isPlaying ? 'Pause' : 'Play'} - ${name || 'this'} clip`;
  const icon = isPlaying ? 'pause' : 'playArrow';
  return (
    <div className={classes.playButtonContainer}>
      {clipErrorMessage ? (
        <div className={classes.statusIconContainer}>
          <Icon type="warning" filled color="error" />
        </div>
      ) : (
        <Button
          variant="icon"
          aria-label={label}
          aria-pressed={isPlaying}
          disabled={isDisabled}
          onClick={togglePlayback}
          className={clsx(
            classes.statusIconAndPlayButton,
            selected ? classes.clipSelected : classes.clipDeselected
          )}
        >
          <Icon
            className={classes.statusIcon}
            type={`${icon}${playbackIconFilled ? 'Filled' : ''}`}
          />
        </Button>
      )}
    </div>
  );
};

export default Playback;
